import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import HandbookChapter from './HandbookChapter.vue';
import CharactersSpecies from '@/pages/Characters/CharactersSpecies.vue';
let HandbookSpecies = class HandbookSpecies extends Vue {
};
HandbookSpecies = __decorate([
    Component({
        components: {
            HandbookChapter,
            CharactersSpecies
        }
    })
], HandbookSpecies);
export default HandbookSpecies;
